const forgotPasswordOptions = {
  email: 'email',
  phone: 'mobile phone',
};

export { forgotPasswordOptions };
